// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file vrp_routing_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JobStop, JobStopJson } from "./job_pb";
import { file_job } from "./job_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vrp_routing_service.proto.
 */
export const file_vrp_routing_service: GenFile = /*@__PURE__*/
  fileDesc("Chl2cnBfcm91dGluZ19zZXJ2aWNlLnByb3RvEglyYWNjb29uYWki6AIKGVNvbHZlU2luZ2xlVmVoaWNsZVJlcXVlc3QSGAoHam9iX2lkcxgBIAMoBFIHam9iX2lkcxIqChBkaXNwb3NhbF9zaXRlX2lkGAIgAigEUhBkaXNwb3NhbF9zaXRlX2lkEi4KEmRyaXZlcl9vbl9zaGlmdF9pZBgDIAEoBFISZHJpdmVyX29uX3NoaWZ0X2lkEiwKEXN0YXJ0X2xvY2F0aW9uX2lkGAQgASgEUhFzdGFydF9sb2NhdGlvbl9pZBI+CgxkZXBhcnR1cmVfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgxkZXBhcnR1cmVfYXQSIQoFc3RvcHMYBiADKAsyEi5yYWNjb29uYWkuSm9iU3RvcBIaCgh0cnVja19pZBgHIAEoBFIIdHJ1Y2tfaWQSKAoEZGF0ZRgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiRwoHVnJwVHJpcBIYCgdqb2JfaWRzGAEgAygEUgdqb2JfaWRzEiIKDHN0b3BfaW5kZXhlcxgCIAMoDVIMc3RvcF9pbmRleGVzItcCChpTb2x2ZVNpbmdsZVZlaGljbGVSZXNwb25zZRIoCg9yZXNwb25zZV9zdGF0dXMYASACKAlSD3Jlc3BvbnNlX3N0YXR1cxIhCgV0cmlwcxgCIAMoCzISLnJhY2Nvb25haS5WcnBUcmlwEi4KEnVuYXNzaWduZWRfam9iX2lkcxgDIAMoBFISdW5hc3NpZ25lZF9qb2JfaWRzEiQKDWVycm9yX21lc3NhZ2UYBCABKAlSDWVycm9yX21lc3NhZ2USKAoPcmVsYXhlZF9qb2JfaWRzGAUgAygEUg9yZWxheGVkX2pvYl9pZHMSOAoXdW5hc3NpZ25lZF9zdG9wX2luZGV4ZXMYBiADKA1SF3VuYXNzaWduZWRfc3RvcF9pbmRleGVzEjIKFHJlbGF4ZWRfc3RvcF9pbmRleGVzGAcgAygNUhRyZWxheGVkX3N0b3BfaW5kZXhlczJ2ChFWcnBSb3V0aW5nU2VydmljZRJhChJTb2x2ZVNpbmdsZVZlaGljbGUSJC5yYWNjb29uYWkuU29sdmVTaW5nbGVWZWhpY2xlUmVxdWVzdBolLnJhY2Nvb25haS5Tb2x2ZVNpbmdsZVZlaGljbGVSZXNwb25zZUI9Ch1jb20ucmFjY29vbmFpLnZycHJvdXRpbmcuZ3JwY0IWVnJwUm91dGluZ1NlcnZpY2VQcm90b1oELi9wYg", [file_google_protobuf_timestamp, file_job]);

/**
 * @generated from message raccoonai.SolveSingleVehicleRequest
 */
export type SolveSingleVehicleRequest = Message<"raccoonai.SolveSingleVehicleRequest"> & {
  /**
   * Exactly one of job_ids or stops is non-empty.
   * Deprecated: use stops (a job_id stop for an existing job). Kept until the
   * frontend moves to stops; then removed and the number reserved.
   *
   * @generated from field: repeated uint64 job_ids = 1 [json_name = "job_ids"];
   */
  jobIds: bigint[];

  /**
   * end location of every trip
   *
   * @generated from field: required uint64 disposal_site_id = 2 [json_name = "disposal_site_id"];
   */
  disposalSiteId: bigint;

  /**
   * driver_on_shift_id or truck_id; when both are set the shift wins. Truck
   * capacity (every call) is truck_type.volume × compaction_factor (unset
   * factor counts as 1).
   *
   * -> truck, depot, shift window
   *
   * @generated from field: optional uint64 driver_on_shift_id = 3 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * Where the vehicle is when the plan starts; affects trip 1 only. Omitted
   * means the truck's depot, i.e. day-planning behaviour. Mid-shift re-routing
   * passes the disposal site, because that is where a truck that just announced
   * itself full actually is - pricing trip 1 from a distant depot changes the
   * order vroom picks for it.
   *
   * @generated from field: optional uint64 start_location_id = 4 [json_name = "start_location_id"];
   */
  startLocationId: bigint;

  /**
   * When the vehicle actually leaves start_location_id. Sets the solver's
   * clock, so job time windows (job.tw_start_at/tw_end_at) and the shift
   * window are evaluated against real wall-clock time rather than from zero.
   *
   * Omitted means the legacy behaviour: the solve is untimed, every window is
   * ignored, and the sequence is chosen on distance and capacity alone. Day
   * planning may legitimately omit it - the departure time is not known until
   * the driver starts - but anything solving for a shift already under way
   * should pass it, or the plan is priced from midnight.
   *
   * With stops, go-backend defaults it to the shift's tw_start_at, else the
   * earliest stop window start, else the start of date (Asia/Almaty).
   * Leaving early only adds waiting, so the default leans early.
   *
   * @generated from field: optional google.protobuf.Timestamp departure_at = 5 [json_name = "departure_at"];
   */
  departureAt?: Timestamp;

  /**
   * Jobs to plan, including ones not created yet (container_group_id +
   * job_type). go-backend fills each container group stop's window as
   * CreateRoutesFromStops picks it; job_id stops use the job's window.
   *
   * @generated from field: repeated raccoonai.JobStop stops = 6;
   */
  stops: JobStop[];

  /**
   * Plan without a shift (stops only, not job_ids): depot from the truck's
   * organization, no shift window. Ignored when driver_on_shift_id is set.
   *
   * @generated from field: optional uint64 truck_id = 7 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * Service day, Asia/Almaty. Picks container group stop windows; required with
   * container group stops.
   *
   * @generated from field: optional google.protobuf.Timestamp date = 8;
   */
  date?: Timestamp;
};

/**
 * @generated from message raccoonai.SolveSingleVehicleRequest
 */
export type SolveSingleVehicleRequestJson = {
  /**
   * Exactly one of job_ids or stops is non-empty.
   * Deprecated: use stops (a job_id stop for an existing job). Kept until the
   * frontend moves to stops; then removed and the number reserved.
   *
   * @generated from field: repeated uint64 job_ids = 1 [json_name = "job_ids"];
   */
  job_ids?: string[];

  /**
   * end location of every trip
   *
   * @generated from field: required uint64 disposal_site_id = 2 [json_name = "disposal_site_id"];
   */
  disposal_site_id?: string;

  /**
   * driver_on_shift_id or truck_id; when both are set the shift wins. Truck
   * capacity (every call) is truck_type.volume × compaction_factor (unset
   * factor counts as 1).
   *
   * -> truck, depot, shift window
   *
   * @generated from field: optional uint64 driver_on_shift_id = 3 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * Where the vehicle is when the plan starts; affects trip 1 only. Omitted
   * means the truck's depot, i.e. day-planning behaviour. Mid-shift re-routing
   * passes the disposal site, because that is where a truck that just announced
   * itself full actually is - pricing trip 1 from a distant depot changes the
   * order vroom picks for it.
   *
   * @generated from field: optional uint64 start_location_id = 4 [json_name = "start_location_id"];
   */
  start_location_id?: string;

  /**
   * When the vehicle actually leaves start_location_id. Sets the solver's
   * clock, so job time windows (job.tw_start_at/tw_end_at) and the shift
   * window are evaluated against real wall-clock time rather than from zero.
   *
   * Omitted means the legacy behaviour: the solve is untimed, every window is
   * ignored, and the sequence is chosen on distance and capacity alone. Day
   * planning may legitimately omit it - the departure time is not known until
   * the driver starts - but anything solving for a shift already under way
   * should pass it, or the plan is priced from midnight.
   *
   * With stops, go-backend defaults it to the shift's tw_start_at, else the
   * earliest stop window start, else the start of date (Asia/Almaty).
   * Leaving early only adds waiting, so the default leans early.
   *
   * @generated from field: optional google.protobuf.Timestamp departure_at = 5 [json_name = "departure_at"];
   */
  departure_at?: TimestampJson;

  /**
   * Jobs to plan, including ones not created yet (container_group_id +
   * job_type). go-backend fills each container group stop's window as
   * CreateRoutesFromStops picks it; job_id stops use the job's window.
   *
   * @generated from field: repeated raccoonai.JobStop stops = 6;
   */
  stops?: JobStopJson[];

  /**
   * Plan without a shift (stops only, not job_ids): depot from the truck's
   * organization, no shift window. Ignored when driver_on_shift_id is set.
   *
   * @generated from field: optional uint64 truck_id = 7 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * Service day, Asia/Almaty. Picks container group stop windows; required with
   * container group stops.
   *
   * @generated from field: optional google.protobuf.Timestamp date = 8;
   */
  date?: TimestampJson;
};

/**
 * Describes the message raccoonai.SolveSingleVehicleRequest.
 * Use `create(SolveSingleVehicleRequestSchema)` to create a new message.
 */
export const SolveSingleVehicleRequestSchema: GenMessage<SolveSingleVehicleRequest, {jsonType: SolveSingleVehicleRequestJson}> = /*@__PURE__*/
  messageDesc(file_vrp_routing_service, 0);

/**
 * One trip of the single vehicle, in visit order. Request with job_ids fills
 * job_ids; request with stops fills stop_indexes (0-based positions in stops).
 *
 * @generated from message raccoonai.VrpTrip
 */
export type VrpTrip = Message<"raccoonai.VrpTrip"> & {
  /**
   * Deprecated with SolveSingleVehicleRequest.job_ids; use stop_indexes.
   *
   * @generated from field: repeated uint64 job_ids = 1 [json_name = "job_ids"];
   */
  jobIds: bigint[];

  /**
   * @generated from field: repeated uint32 stop_indexes = 2 [json_name = "stop_indexes"];
   */
  stopIndexes: number[];
};

/**
 * One trip of the single vehicle, in visit order. Request with job_ids fills
 * job_ids; request with stops fills stop_indexes (0-based positions in stops).
 *
 * @generated from message raccoonai.VrpTrip
 */
export type VrpTripJson = {
  /**
   * Deprecated with SolveSingleVehicleRequest.job_ids; use stop_indexes.
   *
   * @generated from field: repeated uint64 job_ids = 1 [json_name = "job_ids"];
   */
  job_ids?: string[];

  /**
   * @generated from field: repeated uint32 stop_indexes = 2 [json_name = "stop_indexes"];
   */
  stop_indexes?: number[];
};

/**
 * Describes the message raccoonai.VrpTrip.
 * Use `create(VrpTripSchema)` to create a new message.
 */
export const VrpTripSchema: GenMessage<VrpTrip, {jsonType: VrpTripJson}> = /*@__PURE__*/
  messageDesc(file_vrp_routing_service, 1);

/**
 * @generated from message raccoonai.SolveSingleVehicleResponse
 */
export type SolveSingleVehicleResponse = Message<"raccoonai.SolveSingleVehicleResponse"> & {
  /**
   * "ok" | "error"
   *
   * @generated from field: required string response_status = 1 [json_name = "response_status"];
   */
  responseStatus: string;

  /**
   * Trips in execution order: the depot-started trip first, the remaining
   * trips all start and end at the disposal site.
   *
   * @generated from field: repeated raccoonai.VrpTrip trips = 2;
   */
  trips: VrpTrip[];

  /**
   * Deprecated with SolveSingleVehicleRequest.job_ids; use
   * unassigned_stop_indexes.
   *
   * @generated from field: repeated uint64 unassigned_job_ids = 3 [json_name = "unassigned_job_ids"];
   */
  unassignedJobIds: bigint[];

  /**
   * @generated from field: optional string error_message = 4 [json_name = "error_message"];
   */
  errorMessage: string;

  /**
   * Jobs whose time window could not be honoured and was widened to the shift
   * window so the job could still be placed. Time windows are hard constraints
   * in vroom: without this relaxation a job that cannot be reached before it
   * closes comes back unassigned, which would silently shrink the route. These
   * jobs ARE in trips - they are served, just late. Without a shift (truck_id)
   * there is no shift window, so the window is widened to the solver's planning
   * horizon instead. Empty when the whole plan is feasible, and always empty
   * when departure_at was omitted.
   * Deprecated with SolveSingleVehicleRequest.job_ids; use relaxed_stop_indexes.
   *
   * @generated from field: repeated uint64 relaxed_job_ids = 5 [json_name = "relaxed_job_ids"];
   */
  relaxedJobIds: bigint[];

  /**
   * Same as unassigned_job_ids / relaxed_job_ids, for a request with stops:
   * 0-based positions in stops.
   *
   * @generated from field: repeated uint32 unassigned_stop_indexes = 6 [json_name = "unassigned_stop_indexes"];
   */
  unassignedStopIndexes: number[];

  /**
   * @generated from field: repeated uint32 relaxed_stop_indexes = 7 [json_name = "relaxed_stop_indexes"];
   */
  relaxedStopIndexes: number[];
};

/**
 * @generated from message raccoonai.SolveSingleVehicleResponse
 */
export type SolveSingleVehicleResponseJson = {
  /**
   * "ok" | "error"
   *
   * @generated from field: required string response_status = 1 [json_name = "response_status"];
   */
  response_status?: string;

  /**
   * Trips in execution order: the depot-started trip first, the remaining
   * trips all start and end at the disposal site.
   *
   * @generated from field: repeated raccoonai.VrpTrip trips = 2;
   */
  trips?: VrpTripJson[];

  /**
   * Deprecated with SolveSingleVehicleRequest.job_ids; use
   * unassigned_stop_indexes.
   *
   * @generated from field: repeated uint64 unassigned_job_ids = 3 [json_name = "unassigned_job_ids"];
   */
  unassigned_job_ids?: string[];

  /**
   * @generated from field: optional string error_message = 4 [json_name = "error_message"];
   */
  error_message?: string;

  /**
   * Jobs whose time window could not be honoured and was widened to the shift
   * window so the job could still be placed. Time windows are hard constraints
   * in vroom: without this relaxation a job that cannot be reached before it
   * closes comes back unassigned, which would silently shrink the route. These
   * jobs ARE in trips - they are served, just late. Without a shift (truck_id)
   * there is no shift window, so the window is widened to the solver's planning
   * horizon instead. Empty when the whole plan is feasible, and always empty
   * when departure_at was omitted.
   * Deprecated with SolveSingleVehicleRequest.job_ids; use relaxed_stop_indexes.
   *
   * @generated from field: repeated uint64 relaxed_job_ids = 5 [json_name = "relaxed_job_ids"];
   */
  relaxed_job_ids?: string[];

  /**
   * Same as unassigned_job_ids / relaxed_job_ids, for a request with stops:
   * 0-based positions in stops.
   *
   * @generated from field: repeated uint32 unassigned_stop_indexes = 6 [json_name = "unassigned_stop_indexes"];
   */
  unassigned_stop_indexes?: number[];

  /**
   * @generated from field: repeated uint32 relaxed_stop_indexes = 7 [json_name = "relaxed_stop_indexes"];
   */
  relaxed_stop_indexes?: number[];
};

/**
 * Describes the message raccoonai.SolveSingleVehicleResponse.
 * Use `create(SolveSingleVehicleResponseSchema)` to create a new message.
 */
export const SolveSingleVehicleResponseSchema: GenMessage<SolveSingleVehicleResponse, {jsonType: SolveSingleVehicleResponseJson}> = /*@__PURE__*/
  messageDesc(file_vrp_routing_service, 2);

/**
 * Basic single-vehicle VRP endpoint (TBO frontend).
 * Plans multi-trip visit sequences for one capacity-constrained truck:
 * trip 1 runs start -> jobs -> disposal site, subsequent trips run
 * disposal site -> jobs -> disposal site. The start defaults to the truck's
 * depot, resolved from the driver-on-shift's organization, so day planning
 * needs no extra input; callers who know where the vehicle actually is pass
 * start_location_id instead.
 *
 * @generated from service raccoonai.VrpRoutingService
 */
export const VrpRoutingService: GenService<{
  /**
   * @generated from rpc raccoonai.VrpRoutingService.SolveSingleVehicle
   */
  solveSingleVehicle: {
    methodKind: "unary";
    input: typeof SolveSingleVehicleRequestSchema;
    output: typeof SolveSingleVehicleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_vrp_routing_service, 0);

